var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.196,
    height: 61.935,
    viewBox: "0 0 65.196 61.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.032,
    y1: 0.069,
    x2: 0.956,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-997-1716.089v-56.566h15.3v-4.37h4.9v4.37H-952.7v-4.37h4.906v4.37H-932.8v56.566Zm4.91-4.906h54.382v-30.494h-54.382Zm0-35.4h54.382v-11.354h-10.08v4.366H-952.7v-4.366H-976.8v4.366h-4.9v-4.366h-10.387Zm29.29,31.888v-4.906h4.83v4.906Zm-8.366,0v-4.906h4.854v4.906Zm-8.294,0v-4.906h4.853v4.906Zm-8.317,0v-4.906h4.853v4.906Zm41.584-9.3v-4.906h4.854v4.906Zm-8.29,0v-4.906h4.853v4.906Zm-8.317,0v-4.906h4.83v4.906Zm-8.366,0v-4.906h4.854v4.906Zm-8.294,0v-4.906h4.853v4.906Zm-8.317,0v-4.906h4.853v4.906Zm41.584-9.262v-4.906h4.854v4.906Zm-8.29,0v-4.906h4.853v4.906Zm-8.317,0v-4.906h4.83v4.906Zm-8.366,0v-4.906h4.854v4.906Z",
    transform: "translate(997 1777.024)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/event_icon.5d9c98673785e56bc1a7ae879112ca56.svg";
export { ForwardRef as ReactComponent };